import React, { useCallback, useMemo } from 'react';
import {
  createStyles, makeStyles, Theme, Grid,
} from '@material-ui/core';

import { Filter, FilterMap } from '../../types/main';
import FilterChip from './FilterChip';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {
    display: 'flex',
    borderBottom: `1px solid ${colors.outlines}`,
    color: palette.filterChip.color,
    overflowX: 'auto',
  },
}), { name: 'FiltersBar' });

type Props = {
  available: string[];
  active: Filter[];
  filters: FilterMap[];
  onChange: (active: Filter[]) => void;
};

const MultipleFilterBar = ({
  available, active, onChange, filters,
}: Props) => {
  const classes = useStyles();

  const availableFilters = useMemo(
    () => filters
      .filter((item) => available.find((filter) => filter === item.key) !== undefined),
    [filters, available],
  );

  const withActiveFilters = useMemo(() => {
    if (active.length > 1) {
      const withoutRequiredFilter = active.filter((item) => filters.find((item2) => item2.key === item.key)).length > 1;
      return availableFilters.map((filter) => ({
        ...filter,
        isActive: active.some(
          (activeFilter) => activeFilter.key === filter.key && activeFilter.value.toString() === filter.value.toString() && (withoutRequiredFilter ? !filter.required : true),
        ),
      }));
    }
    return availableFilters.map((filter) => ({
      ...filter,
      isActive: active.some(
        (activeFilter) => activeFilter.key === filter.key && activeFilter.value.toString() === filter.value.toString(),
      ),
    }));
  },
  [availableFilters, active, filters]);

  const handleChange = useCallback(
    (filter: Filter, state: boolean, multi: boolean) => {
      const multipleFilters = (filter.filters) ? filter.filters : [];
      if (multi) {
        if (state) {
          return onChange([...active, filter, ...multipleFilters]);
        }

        return onChange(
          active.filter((activeFilter) => activeFilter.key !== filter.key),
        );
      }

      return onChange([filter, ...multipleFilters]);
    },
    [active, onChange],
  );

  return (
    <>
      {withActiveFilters.length > 0 && (
        <Grid className={classes.root}>
          {withActiveFilters.map((filter) => (
            <FilterChip
              {...filter}
              objKey={filter.key}
              onChange={handleChange}
              key={`${filter.key}-${filter.label}`}
            />
          ))}
        </Grid>
      )}
    </>
  );
};

export default MultipleFilterBar;
